import { AUTOCOMPLETE } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface AutoCompleteItem {
    address: string,
    city: string,
    roll: string
}

export interface AutoCompleteResponse extends BaseAsyncReducerState {
    results: Array<AutoCompleteItem>
}

// Define an initial state value for the app
const initialState: AutoCompleteResponse  = {
    loading: false,
    error: false,
    results: []
}


function AutoCompleteReducer(state = initialState, action: AppAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case AUTOCOMPLETE.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case AUTOCOMPLETE.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case AUTOCOMPLETE.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case AUTOCOMPLETE.RESET:
            return {
                ...state,
                loading: false,
                error: payload,
                results: []
            };
        default:
            return state
        }
}

export default AutoCompleteReducer;